export default __webpack_public_path__ + "static/media/ballon.9cee63b9.svg";